import { useState } from "react";
import "./step1.css";
import room1 from "./images/room1.jpg";
import room2 from "./images/room2.jpg";
import room3 from "./images/room3.jpg";
import DateSelector from "./components/DateSelector";

interface Room {
  name: string;
  image: string;
  single: number;
  double: number;
}

interface Step1Props {
  onNext: () => void;
  checkIn: Date | null;
  checkOut: Date | null;
  setCheckIn: (date: Date | null) => void;
  setCheckOut: (date: Date | null) => void;
  selectedRoom: Room | null;
  setSelectedRoom: (room: Room) => void;
}

export const ROOM_OPTIONS: Room[] = [
  {
    name: "King Deluxe Room",
    image: room1,
    single: 250,
    double: 270,
  },
  {
    name: "King Deluxe Suite",
    image: room2,
    single: 360,
    double: 380,
  },
  {
    name: "King Executive Suite",
    image: room3,
    single: 400,
    double: 420,
  },
];

const Step1: React.FC<Step1Props> = ({
  onNext,
  checkIn,
  checkOut,
  setCheckIn,
  setCheckOut,
  selectedRoom,
  setSelectedRoom,
}) => {
  const selectedRoomIndex = ROOM_OPTIONS.findIndex(
    (r) => r.name === selectedRoom?.name
  );

  return (
    <div className="step-content-container">
      <div className="date-picker-row">
        <DateSelector
          checkIn={checkIn}
          checkOut={checkOut}
          setCheckIn={setCheckIn}
          setCheckOut={setCheckOut}
          selectedRoom={null}
        />
        <div className="extend-stay-info">
          <p className="extend-question">
            <strong style={{ color: "#F0B429", fontSize: 22 }}>
              Need to Extend Your Stay?
            </strong>
          </p>
          <p className="extend-message">
            Planning to arrive before{" "}
            <strong className="date-strong">12th November 2025</strong> or stay
            beyond <strong className="date-strong">18th November 2025</strong>{" "}
            at Conrad Dubai?
            <br />
            Please reach out to us directly at&nbsp;
            <a href="mailto:accommodation@uaefma.com">
              accommodation@uaefma.com
            </a>{" "}
            or&nbsp;
            <a href="mailto:imukhtar@altayer-travel.com">
              imukhtar@altayer-travel.com
            </a>
            .
          </p>
        </div>
      </div>

      <div className="room-cards-grid">
        {ROOM_OPTIONS.map((room, idx) => (
          <div
            className={`room-card ${
              selectedRoomIndex === idx ? "selected" : ""
            }`}
            key={idx}
            onClick={() => setSelectedRoom(room)}
          >
            <img src={room.image} alt={room.name} />
            <div className="content">
              <h3>{room.name}</h3>
              <p className="description">Additional room information here</p>
              <div className="prices">
                <div className="price-row">
                  <span>Single Occupancy</span>
                  <span className="price">${room.single.toFixed(2)}</span>
                </div>
                <div className="price-row">
                  <span>Double Occupancy</span>
                  <span className="price">${room.double.toFixed(2)}</span>
                </div>
              </div>
              <p className="note">
                All rates include breakfast and applicable taxes.
              </p>
            </div>
          </div>
        ))}
      </div>

      <p className="final-note">
        Final confirmation will be emailed after submission.
      </p>

      {/* <div className="next-button" style={{ backgroundColor: "#fff"}}>
        <button onClick={onNext} disabled={selectedRoom === null}>
          Next: Guest Details
        </button>
      </div> */}
      {/* Inline Next button for desktop */}
      <div className="next-button inline" style={{ backgroundColor: "#fff" }}>
        <button onClick={onNext} disabled={selectedRoom === null}>
          Next: Guest Details
        </button>
      </div>

      {/* Floating Next button for mobile */}
      <div className="floating-next-button">
        <button onClick={onNext} disabled={selectedRoom === null}>
          Next: Guest Details
        </button>
      </div>
    </div>
  );
};

export default Step1;
